import { CARTEIRINHA_COLUMNS } from "./carteirinhas-columns";
import { ICarteirinha } from "./types";

const FIELD_SEPARATOR = ";";
const LINE_SEPARATOR = "\r\n";
const UTF8_BOM = "﻿";

// Dados de carteirinha vem de feed externo da operadora, entao um valor
// comecando com "=", "+", "@", tab ou CR pode ser interpretado como formula
// pelo Excel/LibreOffice ao abrir o CSV (formula injection). O apostrofo
// no inicio faz a planilha tratar o resto como texto literal. "-" sozinho
// e o placeholder de campo nulo (ver `text`/`formatPrice`/`formatVigency`
// em carteirinhas-columns.ts) e deve passar intacto; ja "-" seguido de mais
// caracteres (ex.: "-1+1") e uma expressao e precisa ser neutralizado tambem.
const FORMULA_TRIGGER = /^[=+@\t\r]/;
const neutralizeFormula = (value: string): string => {
  if (FORMULA_TRIGGER.test(value)) return `'${value}`;
  if (value.startsWith("-") && value.length > 1) return `'${value}`;
  return value;
};

const escapeField = (value: string) => {
  const safe = neutralizeFormula(value);
  return /[;"\n\r]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
};

export function buildCarteirinhasCsv(data: ICarteirinha[]): string {
  const header = CARTEIRINHA_COLUMNS.map((column) => escapeField(column.header));
  const rows = data.map((row) =>
    CARTEIRINHA_COLUMNS.map((column) => escapeField(column.format(row))),
  );

  return (
    UTF8_BOM +
    [header, ...rows].map((fields) => fields.join(FIELD_SEPARATOR)).join(LINE_SEPARATOR)
  );
}
